import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
  name: "loader",
  initialState: {
    loading: false,
    reqQueue: [],

    //apiGet funtion -aas busad gazar loader -g garaas duudaj ajilluulna.
    customLoading: false,
  },
  reducers: {
    showLoader: (state) => {
      state.reqQueue.push(true);
      state.loading = state.reqQueue.length > 0 ? true : false;
    },
    hideLoader: (state) => {
      state.reqQueue.pop();
      state.loading = state.reqQueue.length > 0 ? true : false;
    },

    showCustomLoader: (state) => {
      state.customLoading = true;
    },
    hideCustomLoader: (state) => {
      state.customLoading = false;
    },
  },
});

export const { showLoader, hideLoader, showCustomLoader, hideCustomLoader } =
  loaderSlice.actions;
export default loaderSlice.reducer;
